/** Survives a failed wipe and prevents native session restoration. */
export const SIGN_OUT_MARKER = "aegae.signedOut.v1";
export function signOutPending(): boolean {
  return localStorage.getItem(SIGN_OUT_MARKER) === "1";
}
export function markSignedOut(): void {
  localStorage.setItem(SIGN_OUT_MARKER, "1");
  localStorage.removeItem("aegae.session.v1");
  localStorage.removeItem("aegae.nativeSignInPending.v1");
}
export function finishSignOut(): void {
  localStorage.removeItem(SIGN_OUT_MARKER);
}
